export default {"src":"/_next/static/media/our-services-tax.63350961.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};